import { Suspense, useMemo } from "react";
import { BrowserRouter } from "react-router-dom";
import { createTheme as createMUITheme, ThemeProvider as MUIThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider, useTheme } from "capitalroadkit";

import Navigation from "./Navigation";
import Routes from "./Routes";
import Loading from "./Loading";
import CSS from "./CSS";
import UserProvider from "./context/UserContext";
import HealthProvider from "./context/HealthContext";
import RoleProvider from "./context/RoleContext";

const App = () => {
  const theme = useTheme();

  const muiTheme = useMemo(
    () =>
      createMUITheme({
        palette: {
          type: theme.mode,
          primary: { main: theme.palette.primary.main },
          secondary: { main: theme.palette.secondary.main },
          success: { main: theme.palette.success.main },
          error: { main: theme.palette.danger.main },
          warning: { main: theme.palette.warning.main },
        },
      }),
    [theme]
  );

  return (
    <MUIThemeProvider theme={muiTheme}>
      <ThemeProvider>
        <CSS>
          <UserProvider>
            <HealthProvider>
              <RoleProvider>
                <BrowserRouter basename="/mse-ui">
                  <Suspense fallback={<Loading />}>
                    <Navigation>
                      <Routes />
                    </Navigation>
                  </Suspense>
                </BrowserRouter>
              </RoleProvider>
            </HealthProvider>
          </UserProvider>
        </CSS>
      </ThemeProvider>
    </MUIThemeProvider>
  );
};

export default App;
